/**
 * Avatar Type Definitions
 * @module shared/types/avatar.types
 *
 * Type definitions for Avatar component.
 */

/**
 * Avatar size options
 * Defines standardized avatar sizes throughout the application
 */
export enum AvatarSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}
